
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
  Instagram,
  Facebook,
  Twitter,
  Youtube,
  LinkedinIcon,
  MapPin, Phone
} from "lucide-react";
import { Link } from "react-router-dom";
import logometa from "../../images/LandingPageImage/Logo-Meta.png";
import Googleplay from "../../images/LandingPageImage/googleplay.png";
import Logo from "../../images/MY-Anlook.png";
import Chaafo from "../../images/chaafo.png"

const Footer = () => {
  const socialLinks = {
    youtube: "https://www.youtube.com/@Anlookofficial",
    insta: "https://www.instagram.com/anlookofficial/",
    facebook: "https://www.facebook.com/anlookfb/",
    linkedin: "https://www.linkedin.com/company/anlook-official/",
  };

  return (
    <footer className="footer-section">
      <Container>
        <Row className="gy-4">
          <Col md={5}>
            <Link to="/get" className="d-inline-block">
              <img src={Logo} alt="Anlook Logo" className="ln-logo" />
            </Link>


           

            <p className="footer-text text-white mt-4 mb-4 fs-6">
              We are a Conversational Engagement Platform empowering businesses
              to engage meaningfully with customers across commerce, marketing
              and support use-cases on 30+ channels
            </p>

            {/* Address CTA */}
            <Button
              variant=""
              className="footer-cta-btn d-flex align-items-start mb-3 text-start border-none text-white"
            >
              <MapPin size={18} className="me-2 mt-1" />
              <span>
                Ithum Tower, Tower-B, 218, Second Floor <br />
                Sector 62, Noida - 201309
              </span>
            </Button>

            {/* Phone CTA */}
            {/* <Button
              variant=""
              className="footer-cta-btn d-flex align-items-center text-white"
              href="tel:+919958853167"
            >
              <Phone size={18} className="me-2" />
              +91-9958853167
            </Button> */}
          </Col>

          <Col md={2}>
            <h6 className="footer-title">Company</h6>
            <ul className="footer-list text-decoration-none">
              <li>
                {" "}
                <a href="/about-us">About us</a>
              </li>
              <li>
                {" "}
                <a href="/pricing-page">Pricing</a>
              </li>
              <li>
                {" "}
                <a href="/blog">Blogs</a>
              </li>
              <li>
                {" "}
                <a href="/contact">Contact Us</a>
              </li>
            </ul>
          </Col>

          <Col md={2}>
            <h6 className="footer-title">Resources</h6>
            <ul className="footer-list">
              <li>
                <a href="/privacy&policy">Privacy Policy</a>
              </li>
              <li>
                <a href="/terms-conditions">Terms & Condition</a>
              </li>
            </ul>
          </Col>

          {/* Right Section */}
          <Col md={3}>
            <div className="mb-3">
              <img src={logometa} alt="Meta Logo" className="playstore-img" />
            </div>

            <a
              href="https://play.google.com/store/apps/details?id=com.application.anlook&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={Googleplay}
                alt="Google Play"
                className="playstore-img"
              />
            </a>

            <div className="mt-4">
              <h6 className="footer-title">Follow Us</h6>

              <div className="social-icons">
                <a
                  href={socialLinks.insta}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <Instagram size={20} />
                </a>

                <a
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <Facebook size={20} />
                </a>

                <a
                  href={socialLinks.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <LinkedinIcon size={20} />
                </a>

                <a
                  href={socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  <Youtube size={20} />
                </a>

                {/* <a
                    href={socialLinks.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                  >
                    <Linkedin size={20} />
                  </a> */}
              </div>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <div className="footer-branding text-center">
          <p className="footer-copy mb-1">
            Anlook © 2026. All rights reserved.
          </p>

          <div className="footer-powered">
            <span>Managed & Powered by</span>
            <img src={Chaafo} alt="Chaafo Logo" className="footer-chaafo-logo" />
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
